// extracted by mini-css-extract-plugin
module.exports = {"hosts":"footer_hosts__z0PX4","partnerLogo":"footer_partnerLogo__qoCfp","container":"footer_container__p3rM6","section":"footer_section__IqTBm","divider":"footer_divider__X5RsN"};